import { allSteps, stepTemporalMetrics } from './project'
import type { ProjectRow } from '../types'

export type ProjectReminder = {
  id: string
  projectId: string
  projectName: string
  stepName: string
  tone: 'urgent' | 'attention' | 'planned'
  title: string
  detail?: string
}

function plural(days: number) {
  return `${days} jour${Math.abs(days) > 1 ? 's' : ''}`
}

export function remindersForProjects(projects: ProjectRow[]): ProjectReminder[] {
  const reminders: ProjectReminder[] = []

  for (const project of projects) {
    for (const step of allSteps(project.snapshot)) {
      const { state } = step
      const metrics = stepTemporalMetrics(state, project.as_of_date)
      const base = {
        projectId: project.id,
        projectName: project.name,
        stepName: step.name,
      }
      if (state.status === 'Bloqué') {
        reminders.push({
          ...base,
          id: `${project.id}:${step.id}:blocked`,
          tone: 'urgent',
          title: 'Étape bloquée',
          detail: state.next_action || 'Une action est à préciser.',
        })
        continue
      }
      if (metrics.deadlineDeltaDays !== undefined && metrics.deadlineDeltaDays < 0) {
        reminders.push({
          ...base,
          id: `${project.id}:${step.id}:overdue`,
          tone: 'urgent',
          title: `Prévision dépassée de ${plural(Math.abs(metrics.deadlineDeltaDays))}`,
          detail: state.next_action,
        })
        continue
      }
      if (state.status === 'En attente') {
        reminders.push({
          ...base,
          id: `${project.id}:${step.id}:waiting`,
          tone: 'attention',
          title: state.waiting_days !== undefined ? `En attente depuis ${plural(state.waiting_days)}` : 'Étape en attente',
          detail: state.next_action,
        })
        continue
      }
      if (metrics.deadlineDeltaDays !== undefined && metrics.deadlineDeltaDays <= 7) {
        reminders.push({
          ...base,
          id: `${project.id}:${step.id}:upcoming`,
          tone: 'planned',
          title: `Prévision dans ${plural(Math.max(0, metrics.deadlineDeltaDays))}`,
          detail: state.next_action,
        })
      }
    }
  }

  const rank: Record<ProjectReminder['tone'], number> = { urgent: 0, attention: 1, planned: 2 }
  return reminders.sort((left, right) => rank[left.tone] - rank[right.tone] || left.projectName.localeCompare(right.projectName, 'fr'))
}
